import type {WorkerType} from 'src/assets/worker-types/schemas'

export function requiresHomeYard(workerTypes: WorkerType[], workerTypeId: string | null): boolean {
    return workerTypes.some((type) => type.id === workerTypeId && type.isDriver)
}
